import {
  IonButton,
  IonInput,
  IonItem,
  IonLabel,
  IonModal,
  IonTextarea,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { CONSTANTS } from "../../../constants/callcentral.constants";
import { dataTransferService } from "../../../services/dataTransferService";
import { utilService } from "../../../services/utilService";
import { setPatientAcceptanceService } from "../PatientAlert/PatientAlert.service";
import "./EMSAlertList.scss";

interface ContainerProps {
  incomingPatientsListData?: any;
  audio: any;
  patientInputParams: any;
  updateList: any;
  isFromRejectStatus?: any;
}
const EMSAlertList: React.FC<ContainerProps> = (props: any) => {
  const [showModalAlert, setShowModalAlert] = useState(false);
  const [showSignInAlert, setShowSignInAlert] = useState(false);
  const [rejectReason, setRejectReason] = useState<string>("");
  const [isInputEmpty, setIsInputEmpty] = useState(true);
  const [isShowPassword, setPasswordStatus] = useState(false);
  const [userName, setUserName] = useState<string>("");
  const [userPassword, setUserPassword] = useState<string>("");
  const [isFormValid, setFormStatus] = useState(false);
  const [isReject, setIsReject] = useState(false);
  const [isAccept, setIsAccept] = useState(false);
  const [isInvalidCredentials, setSignInValidations] = useState(false);

  useEffect(() => {
    setFormStatus(formValidation());
  }, [userName, userPassword]);

  const formValidation = () => {
    return userName && userPassword ? true : false;
  };

  const acceptPatientToHospital = () => {
    let params = {
      ems_network_code: props.patientInputParams.ems_network_code,
      ems_source_id: props.patientInputParams.ems_source_id,
      is_accepted: true,
      action_username: userName,
      action_password: userPassword,
      user_guid: utilService.getLoggedUserGuid(),
    };
    AcceptPatient(params);
  };

  const onShowPassword = () => {
    setPasswordStatus(!isShowPassword);
  };

  async function AcceptPatient(params: any) {
    const respPatientAcceptanceResult: any =
      await setPatientAcceptanceService.patientAcceptance(params);
    if (respPatientAcceptanceResult.isSuccess) {
      props.updateList(params.ems_source_id);
      dataTransferService.caseHistoryUpdatedAction(true);
      setShowSignInAlert(false);
      setUserName("");
      setUserPassword("");
      if (props?.incomingPatientsListData?.length == 0) {
        props?.audio.pause();
      }
    } else {
      setSignInValidations(true);
      console.log("error");
    }
  }

  const rejectPatient = () => {
    let params = setRejectedUserParams();
    RejectPatient(params);
  };

  async function RejectPatient(params: any) {
    const respPatientRejectResult: any =
      await setPatientAcceptanceService.patientAcceptance(params);
    if (respPatientRejectResult.isSuccess) {
      props.updateList(params.ems_source_id);
      dataTransferService.caseHistoryUpdatedAction(true);
      setShowSignInAlert(false);
      setUserName("");
      setUserPassword("");
      if (props?.incomingPatientsListData?.length == 0) {
        props?.audio.pause();
      }
    } else {
      setSignInValidations(true);
      console.log("error");
    }
  }

  const emtAccept = () => {
    let params = setEMTAccept();
    emtDataAccept(params);
    // stoping audio if the list is gonna become empty
      if(props?.incomingPatientsListData?.length===1){
        props?.audio.pause();
      }
  };

  const setEMTAccept = () => {
    return {
      patient_guid: props.patientInputParams.patient_guid,
      user_guid: utilService.getLoggedUserGuid(),
      is_seen: true,
    };
  };

  async function emtDataAccept(params: any) {
    const resp: any = await setPatientAcceptanceService.emtAcceptData(params);
    if (resp.isSuccess) {
      props.updateList(props.patientInputParams.ems_source_id);
      dataTransferService.caseHistoryUpdatedAction(true);
    } else {
      console.log("error");
    }
  }

  const checkIfInputEmpty = () => {
    const isWhitespace = utilService.checkIfInputEmpty("groupSmsText");
    setIsInputEmpty(isWhitespace);
  };

  const setRejectedUserParams = () => {
    return {
      ems_network_code: props.patientInputParams.ems_network_code,
      ems_source_id: props.patientInputParams.ems_source_id,
      is_accepted: false,
      reason: rejectReason,
      action_username: userName,
      action_password: userPassword,
      user_guid: utilService.getLoggedUserGuid(),
    };
  };

  const modifyPatientToHospital = () => {
    if (isAccept) {
      acceptPatientToHospital();
    } else if (isReject) {
      rejectPatient();
    }
  };

  const updatePatientName = (patientName: any) => {
    let updatedPatientName = patientName.replace(/[,]/g, " ");
    return updatedPatientName;
  };

  return (
    <>
      <div className="ems-main-section">
        <div className="ems-main-container">
          {!props.isFromRejectStatus && (
            <div className="ems-content-area">
              <div className="ems-alert-label">
                <span className="label-ems">Created on: </span>
                <span className="ems-alert-details">
                  {props.patientInputParams &&
                  props.patientInputParams.created_on
                    ? props.patientInputParams.created_on
                    : ""}
                </span>
              </div>
              <div className="ems-alert-label">
                <span className="label-ems">Case Type: </span>

                <span className="ems-alert-details">
                  {props.patientInputParams &&
                  props.patientInputParams.patient_case_types.length
                    ? props.patientInputParams.patient_case_types[0]
                    : "-Not selected-"}
                  {props.patientInputParams &&
                  props.patientInputParams.patient_case_types.length >= 2
                    ? ` ( ${props.patientInputParams.patient_case_types.length} )`
                    : ""}
                </span>
              </div>
              <div className="ems-alert-label">
                <span className="label-ems">Patient Name: </span>
                <span className="ems-alert-details">
                  {props.patientInputParams &&
                  props.patientInputParams.display_name
                    ? updatePatientName(props.patientInputParams.display_name)
                    : ""}
                </span>
              </div>
              <div className="ems-alert-label">
                <span className="label-ems">ETA: </span>
                <span className="ems-alert-details">
                  {props.patientInputParams && props.patientInputParams.eta
                    ? props.patientInputParams.eta
                    : ""}
                </span>
              </div>
              {props.patientInputParams.message && (
                <div className="ems-alert-label">
                  <span className="label-ems ems-message-label">
                    Message From EMT:{" "}
                  </span>

                  <span className="ems-alert-details emt-Message">
                    {props.patientInputParams &&
                    props.patientInputParams.message
                      ? props.patientInputParams.message
                      : ""}
                  </span>
                </div>
              )}
            </div>
          )}

          {props.isFromRejectStatus && (
            <>
              <div className="ems-alert-label">
                <span className="label-ems">Rejected By: </span>
                <span className="ems-alert-details">
                  {props.patientInputParams &&
                  props.patientInputParams.rejected_by
                    ? props.patientInputParams.rejected_by
                    : ""}
                </span>
              </div>
              <div className="ems-alert-label">
                <span className="label-ems">Patient Name: </span>
                <span className="ems-alert-details">
                  {props.patientInputParams &&
                  props.patientInputParams.patient_name
                    ? updatePatientName(props.patientInputParams.patient_name)
                    : ""}
                </span>
              </div>

              <div className="ems-alert-label">
                <span className="label-ems">Site Name: </span>
                <span className="ems-alert-details">
                  {props.patientInputParams &&
                  props.patientInputParams.rejected_site_name
                    ? props.patientInputParams.rejected_site_name
                    : ""}
                </span>
              </div>

              <div className="ems-alert-label">
                <span className="label-ems ems-message-label">
                  Message From Hospital:{" "}
                </span>
                <span className="ems-alert-details emt-Message">
                  {props.patientInputParams && props.patientInputParams.reason
                    ? props.patientInputParams.reason
                    : ""}
                </span>
              </div>
            </>
          )}

          {!props.isFromRejectStatus && (
            <div className="alert-button-container">
              <div className="cancel-button-div">
                <IonButton
                  color="medium"
                  className="button secondary-btn  btn-curved ems-alert-button"
                  onClick={() => {
                    setShowModalAlert(true);
                    setUserName("");
                    setUserPassword("");
                    setRejectReason("");
                  }}
                >
                  Reject
                </IonButton>
              </div>
              <div className="send-button-div">
                <IonButton
                  className="submit-btn button primary-btn btn-curved ems-alert-button"
                  onClick={() => {
                    setShowSignInAlert(true);
                    setIsReject(false);
                    setIsAccept(true);
                    setUserName("");
                    setUserPassword("");
                    setIsInputEmpty(true);
                  }}
                >
                  Accept
                </IonButton>
              </div>
            </div>
          )}
          {props.isFromRejectStatus && (
            <div className="alert-button-container">
              <div className="send-button-div">
                <IonButton
                  className="submit-btn button primary-btn btn-curved ems-alert-button"
                  onClick={() => {
                    emtAccept();
                  }}
                >
                  Ok
                </IonButton>
              </div>
            </div>
          )}
        </div>
      </div>
      <IonModal
        isOpen={showModalAlert}
        backdropDismiss={false}
        className=" add-fav-modal reject-patient-modal"
      >
        <div className="label-div">
          <div className="label-name">Reject Patient</div>
          <div
            className="input-icon icon-close"
            onClick={() => {
              setShowModalAlert(false);
              setRejectReason("");
            }}
          ></div>
        </div>
        <div className="comment-box">
          <IonTextarea
            className="textarea-div"
            maxlength={250}
            value={rejectReason}
            placeholder="Reason to reject patient"
            id="groupSmsText"
            onIonChange={(e) => {
              checkIfInputEmpty();
              setRejectReason(e.detail.value!);
            }}
          ></IonTextarea>
        </div>

        <div className="add-fav-button-container">
          <div className="cancel-button-div">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                // setShowModalAlert(false);
                setRejectReason("");
              }}
            >
              Clear
            </IonButton>
          </div>
          <div className="send-button-div">
            <IonButton
              disabled={isInputEmpty}
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                setShowModalAlert(false);
                setShowSignInAlert(true);
                setIsReject(true);
                setIsAccept(false);
              }}
            >
              Reject
            </IonButton>
          </div>
        </div>
      </IonModal>

      <IonModal
        isOpen={showSignInAlert}
        backdropDismiss={false}
        className="add-fav-modal sign-In-modal-EMS"
      >
        <div className="label-div">
          <div className="label-name">Sign In</div>
          <div
            className="input-icon icon-close"
            onClick={() => {
              setShowSignInAlert(false);
              setSignInValidations(false);
              setIsInputEmpty(true);
            }}
          ></div>
        </div>
        <form className="sign-in-input-container">
          <div className="signin-input-wrapper">
            <IonItem className="item-input">
              <IonLabel className="item-label" position="floating">
                Username
              </IonLabel>
              <IonInput
                className="ion-input"
                name="username"
                type="search"
                value={userName}
                onIonChange={(event) => {
                  setSignInValidations(false);
                  setUserName(event.detail.value!);
                }}
                maxlength={25}
                autocomplete="on"
              >
                {" "}
              </IonInput>
            </IonItem>
          </div>
          <div className="signin-input-wrapper">
            <div
              className={`input-icon clickable ${
                isShowPassword ? "icon-show_password" : "icon-hide_password"
              }`}
              onClick={onShowPassword}
            ></div>
            <IonItem className="item-input">
              <IonLabel className="item-label" position="floating">
                Password
              </IonLabel>
              <IonInput
                className="ion-input"
                type={isShowPassword ? "text" : "password"}
                name="password"
                value={userPassword}
                onIonChange={(event) => {
                  setUserPassword(event.detail.value!);
                  setSignInValidations(false);
                }}
                autocomplete="new-password"
              >
                {" "}
              </IonInput>
            </IonItem>
          </div>
          <div className="signin-validations" hidden={!isInvalidCredentials}>
            {CONSTANTS.MESSAGES.SIGN_IN_VALIDATION}
          </div>
        </form>

        <div className="add-fav-button-container">
          <div className="cancel-button-div sign-in-btn">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                setUserName("");
                setUserPassword("");
              }}
            >
              Clear
            </IonButton>
          </div>
          <div className="send-button-div sign-in-btn">
            <IonButton
              disabled={!isFormValid}
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                modifyPatientToHospital();
                // props?.audio.pause();
              }}
            >
              Sign In
            </IonButton>
          </div>
        </div>
      </IonModal>
    </>
  );
};

export default EMSAlertList;
